module.exports = __webpack_public_path__ + "img/amazingBox.a4df8c34.png";